import clsx from "clsx";
import Link from "next/link";
import styled from "styled-components";
import Image from "components/Image";
import { responsive } from "utils/theme";

const LabCard = ({ data, className, size = "small", single = false }) => {
  return (
    <Link href={data.link} prefetch={false}>
      <a
        className={clsx(
          "tw-flex tw-w-full tw-flex-col tw-group tw-m-0",
          className,
          {
            "sm:tw-w-1/2 tw-mx-auto": single,
            "lg:tw-w-2/3": size === "large",
            "lg:tw-w-[calc(100%/3)]": size !== "large",
          }
        )}
      >
        <div
          className={clsx("tw-w-full", {
            "md:tw-aspect-[6/2]": size === "large",
          })}
        >
          <div
            className={clsx(
              "tw-relative tw-rounded-lg tw-h-full tw-overflow-hidden",
              {
                "tw-aspect-[3/2]": size !== "large",
                "tw-aspect-[6/2]": size === "large",
              }
            )}
          >
            <Image
              width={size === "small" ? 300 : 600}
              height={200}
              src={data?.image}
              alt={data?.alt}
              className={clsx(
                "tw-transition-all tw-rounded-lg xxxl:tw-rounded-[10.67px] tw-w-full tw-h-full tw-object-cover"
              )}
              loading="eager"
            />
            <div className="tw-rounded-lg tw-text-lg xxxl:tw-rounded-[10.67px] tw-font-medium tw-absolute tw-top-0 tw-w-full tw-h-full tw-flex tw-bg-gradient-to-b tw-items-end tw-pr-5 tw-pb-4 gradiant"></div>
          </div>
        </div>
        <span
          className={clsx(
            "tw-text-[#344456] tw-text-base xxxl:tw-text-[21.33px] tw-font-bold tw-mt-4 group-hover:tw-text-[#007FAC] tw-transition-all tw-min-h-[50px] xxxl:tw-mt-5 xxxl:tw-leading-[36.17px] title"
          )}
        >
          {data?.title
            ?.split?.(" ")
            ?.map?.((item, i, arr) =>
              Number.isNaN(+item) ? (
                arr?.length === i + 1 ? (
                  item
                ) : (
                  `${item} `
                )
              ) : (
                <bdi className="ENGLISH_FONTS">{`${item} `}</bdi>
              )
            ) ?? ""}
        </span>
      </a>
    </Link>
  );
};

const StyledLabCard = styled(LabCard)`
  .title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .gradiant {
    background: linear-gradient(
      180deg,
      rgba(52, 68, 86, 0) 66.67%,
      rgba(52, 68, 86, 0.7) 100%
    );
  }
  img {
    transition: transform 0.3s;
    @media (max-width: ${responsive.md}px) {
      transform: scaleY(1.06);
    }
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

export default StyledLabCard;
